import React, { Component } from "react";
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBContainer } from "mdbreact";
import BannerSlide from "./BannerHomeSlidesSet.js";
import Spinner from '../Spinner/Spinner.js';
import { detailReactCarouselControls } from "../../helpers/DetailReactCarouselControls.js";
import { itemColorChangeSwitch, createSpecialUList, simulateClickOnEvent, $qs, controlElementBasedOnScrollVisibility, getCurrentSeason, getMediaQueryMatch } from "../../helpers/misc-javascript-helpers.js";

class BannerHomeV2 extends Component {
  constructor(props) {
    super(props);
    this.carouselRef = React.createRef();
    this.state = {
      bannerData: {},
      isLoading: false,
      /* Change control color reference - based on slide indexes. */
      btnColorsChangeOn: { triggeringSlides: [2] },
      /* Switch color options for the carousel controls. */
      controlColorSwitch: { normalColor: '#000000', changeToColor: '#FFFFFF' },
      currentControlColor: '', // for testing
      selectedIndex: 0,
      loadedOnce: false,
      carouselPaused: false,
      disabledCounter: 0,
      mediaStatus: {},
      currentSeason: ''
    };

    /* Instance variables */
    this.carouselControlButtons = '';
    this.controlDotsRows = '';
    this.carouselContainer = '';
    this.htmlSrcElement = '';
    this.detailCarouselControls = this._detailCarouselControls.bind(this);
    this._checkSlidesChange = this._checkSlidesChange.bind(this);
    this.handleSlideChange = this.handleSlideChange.bind(this);
    /* FIX-ME - Disabling - causes screen to jitter */
    // this.handlePauseCarousel = this._handlePauseCarousel.bind(this);
    this.mediaQueryListObj = { mobile: "(max-width: 47.9375em)", tablet: "(min-width: 48em) and (max-width: 99.9375em)", desktop: "(min-width: 100em)" };
    this.backgroundImagePath = 'https://cdn.skyelearning.com/static/background-images/home-page/main-banner/';

    /* Bindings */
    this.detailCarouselControls = this._detailCarouselControls.bind(this);
    this._checkSlidesChange = this._checkSlidesChange.bind(this);
    this.handleSlideChange = this.handleSlideChange.bind(this);
    this.handleMediaQueryMatch = this.handleMediaQueryMatch.bind(this);

    window.addEventListener('load', this.handleMediaQueryMatch);
    window.addEventListener('resize', this.handleMediaQueryMatch);
  }

  componentDidMount() {
    /* Load the slides */
    this.getSlidesCall();
    /* Start the MutationObserver */
    this._checkSlidesChange();
    /* Set the carousel controls in a variable for accessibility treatment */
    if (document.querySelector('.banner-carousel__block')) {
      this.carouselContainer = document.querySelector('.banner-carousel__block');
      this.setCarouselControllers(this.carouselContainer);
      this.setupCarouselControlKeyEvents(this.carouselControlButtons[0], this.carouselControlButtons[1]);
    }

    if (document.querySelector('html,body') && this.carouselContainer) {
      this.htmlSrcElement = document.querySelector('html,body');

      if (window.navigator.userAgent.match(/Edge/)) {
        // IE Edge target for scrollTop
        this.htmlSrcElement = document.body;
      }
      /* FIX-ME - Disabling - causes screen to jitter */
      // window.addEventListener('load', this.handlePauseCarousel);
      // window.addEventListener('scroll', this.handlePauseCarousel);
    }
  };

  componentDidUpdate() {
    /* If this is the first load adjust the controllers and indicator items */
    if (!this.state.loadedOnce && this.state.bannerData.length > 1) {
      /* Add accessibility to the carousel controls */
      this.detailCarouselControls();
      if (document.querySelector('.banner-slide__control__dots')) {
        this.controlDotsRows = document.querySelectorAll('.banner-slide__control__dots');
        createSpecialUList('ul', 'li', 'ncontrol-dots', 'ndots', this.state.bannerData.length, this.controlDotsRows);
        this.setState({ loadedOnce: true });
      }
    }
  }

  /**
   * This method is used for retrieving data (either from a JSON file or API) and setting it to the bannerData state.
   */
  async getSlidesCall() {
    let allSlides = { data: [] };
    let returnedData;
    try {
      /* Check the props type for 'function' to make api call. */
      if (typeof this.props.data === "function") {
        allSlides = await this.props.data();
        returnedData = allSlides.data.data ? allSlides.data.data : {};
        /* Otherwise take the data directly - as is. */
      } else {
        allSlides = this.props.data ? this.props.data : {};
        returnedData = allSlides ? allSlides : {};
      }
      /* Remove any slide item that is not active. */
      const returnedActiveData = this.getActiveSlidesOnly(returnedData);
      /* Set the bannerData using returned data. */
      this.setState({ bannerData: returnedActiveData });
      this.carouselRef.current.setState({ length: returnedActiveData.length });
      this.setState({ currentSeason: this.handleCurrentSeason(new Date()) });
      /* Set loading to false. */
      this.setState({ isLoading: false });
    } catch (error) {
      console.error(error);
    }
  }

  /** Getter - Directly accesses the Carousel state for the selectedItem index */
  getSelectedSlideIndex() {
    this.setState({ selectedIndex: this.carouselRef.current.state.activeItem });
    return this.carouselRef.current.state.activeItem;
  }

  /** For the meantime until the slides data is provided by an API
   * this method will remove inactive slides as specified in json file.
  */
  getActiveSlidesOnly(array = new Array()) {
    const newArray = array.filter(item => item.active == true);
    return newArray;
  }

  /** Turns off the carousel when it is outside of a safe area (offscreen) */
  _handlePauseCarousel() {
    const clientElement = this.htmlSrcElement;
    let carouselScrollStatusMessage = false;
    carouselScrollStatusMessage = controlElementBasedOnScrollVisibility(this.state.disabledCounter, this.state.carouselPaused,
      this.carouselContainer, this.htmlSrcElement, clientElement, null, null);
    /* Set relevant states to be used in controlling props or as variable references */
    if (carouselScrollStatusMessage.hasJustUpdated) {
      this.setState({ carouselPaused: carouselScrollStatusMessage.status });
      this.setState({ disabledCounter: carouselScrollStatusMessage.disInteger });
      /* Use carouselScrollStatusMessage to set the length to 0 is carousel is to be paused otherwise set to length of bannerData state */
      this.carouselRef.current.setState({ length: (this.state.carouselPaused) ? 1 : this.state.bannerData.length });
    }
  }

  /** Getter for the carousel controls */
  getCarouselControllers() {
    return this.carouselControlButtons;
  }

  /**
   * This method uses the imported function detailReactCarouselControls to change the carousel control button's
   * icons and their associated accessibility properties (aria-label, aria-hidden).
   */
  _detailCarouselControls() {
    if (document.querySelector(".banner-carousel__block")) {
      this.carouselContainer = document.querySelector(".banner-carousel__block");
      const carouselControllersSet = this.getCarouselControllers();
      detailReactCarouselControls(carouselControllersSet, "i", "carousel-next__ctrl", "carousel-previous__ctrl");
    }
  }

  /**
   * Orchestrates the detection of each slide's class changes through MutationObserver which
   * observes changes in the DOM Tree of the carousel.
   */
  _checkSlidesChange() {
    const carouselSubject = document.querySelector('.carousel.carousel-fade');
    const configureObserve = { attributes: true, childlist: true, subtree: true };
    const myObserver = new MutationObserver(this.handleSlideChange);
    myObserver.observe(carouselSubject, configureObserve);
  }

  /**
   * This is a custom method that will use the values from the state.btnColorsChangeOn array
   * to change the control colors at a specific slide index when it's selected or active. Those
   * values in the state have to be set manually, based preference and corresponding with slide indexes
   * 
   * @param {HTMLObject} targetedElement - mutation observer target;
   * 
   * @param {object} observer - an object that contains the config for the mutation observer
   */
  handleSlideChange(targetedElement, observer) {
    /* Make a copy of the incoming targetedElement Mutation object. */
    let targetedElementCopy = targetedElement;
    const actionButtons = this.carouselControlButtons;
    const carouselSlides = document.querySelectorAll(".banner-carousel__block .carousel-item");
    const currentIndex = this.getSelectedSlideIndex() - 1;
    observer.disconnect();
    if (actionButtons && carouselSlides) {
      /* Alternating colors for control buttons. */
      const ctrlColorSwitchSet = this.state.controlColorSwitch;
      let doColorChange = false;
      let targetedIndexes = this.state.btnColorsChangeOn.triggeringSlides;

      if (Object.keys(targetedElementCopy).length > 0) {
        let tindex = 0;
        for (tindex = 0; tindex < targetedIndexes.length; tindex++) {
          if (targetedIndexes[tindex] === currentIndex) {
            doColorChange = true;
            break;
          } else {
            doColorChange = false;
          }
        }
        itemColorChangeSwitch(actionButtons, doColorChange, ctrlColorSwitchSet.changeToColor, ctrlColorSwitchSet.normalColor);
        this._checkSlidesChange();
      }
    }
  };

  /** Setup keyboard Enter press simulation for carousel controls */
  setupCarouselControlKeyEvents(previousController, nextController) {
    simulateClickOnEvent({ which: 13, code: 'Enter' }, previousController, 'keydown');
    simulateClickOnEvent({ which: 13, code: 'Enter' }, nextController, 'keydown');
  }

  /** Setter the carousel controls and add needed classes for additional use in the carousel 
   * @param {HTMLElement} - the parentContainer of the carousel control buttons.
  */
  setCarouselControllers(parentContainer) {
    const carouselControllerNext = parentContainer.querySelector(".carousel-control-next");
    const carouselControllerPrev = parentContainer.querySelector(".carousel-control-prev");
    carouselControllerPrev.classList.add('control-prev');
    carouselControllerNext.classList.add('control-next');
    this.carouselControlButtons = [carouselControllerPrev, carouselControllerNext];
  }

  /** Handles the media query match - using helper method getMediaQueryMatch()
   * @return on object of booleans that tell which provided queries are active (true) and which are not(false)
  */
  handleMediaQueryMatch() {
    this.setState({ mediaStatus: getMediaQueryMatch(this.mediaQueryListObj) });
    /* return object with booleans to get current media query data */
    return getMediaQueryMatch(this.mediaQueryListObj);
  };

  /** Determine the season based on the calendar */
  handleCurrentSeason(date) {
    return getCurrentSeason(date);
  }

  /** Set the season using a Date() object */
  setCurrentSeason(dateObject) {
    this.setState({ currentSeason: dateObject });
  }

  /* Carousel slide forwarding - for testing purposes */
  forwardSlide() {
    const currentSlide = this.carouselRef.current.state.activeItem;
    if (this.carouselRef.current.state.activeItem === 4) {
      this.carouselRef.current.setState({ activeItem: 1 });
    } else {
      this.carouselRef.current.setState({ activeItem: (currentSlide + 1) });
    }
    this.getSelectedSlideIndex();
  }
  
  /* Carousel slide reversal - for testing purposes */
  reverseSlide() {
    const currentSlide = this.carouselRef.current.state.activeItem;
    if (this.carouselRef.current.state.activeItem === 1) {
      this.carouselRef.current.setState({ activeItem: 4 });
    } else {
      this.carouselRef.current.setState({ activeItem: (currentSlide - 1) });
    }
    this.getSelectedSlideIndex();
  }

  render() {
    return (
      <div className="banner-carousel__block">
        <Spinner isLoading={this.state.isLoading}></Spinner>
        <MDBContainer>
          <MDBCarousel
            activeItem={1}
            length={this.props.dataLength ? this.props.dataLength : 1}
            showControls={true}
            showIndicators={false}
            className="z-depth-1"
            interval={this.state.carouselPaused ? 0 : 8500}
            ref={this.carouselRef}
          >
            <MDBCarouselInner>

              {this.state.bannerData.length > 0 ? this.state.bannerData.map((slide, index) =>
                <MDBCarouselItem itemId={index + 1} key={'mdb' + index}>
                  <BannerSlide
                    count={index + 1}
                    active={slide.active}
                    slideName={slide.slide}
                    image={slide.image}
                    heading={slide.heading}
                    subheading={slide.subheading}
                    content={slide.content}
                    author={slide.author}
                    ctaText={slide.ctaText}
                    ctaLink={slide.ctaLink}
                    backgroundImage={slide.backgroundImage}
                    ctaTextColor={slide.ctaTextColor}
                    ctaBackgroundColor={slide.ctaBackgroundColor}
                    ctaHoverColors={slide.ctaHoverColors}
                    breakingPoints={this.mediaQueryListObj}
                    mobileMediaStatus={this.state.mediaStatus.mobile}
                    tabletMediaStatus={this.state.mediaStatus.tablet}
                    desktopMediaStatus={this.state.mediaStatus.desktop}
                    isSeasonal={slide.seasonal}
                    season={this.state.currentSeason}
                    bgImagePath={this.backgroundImagePath}
                    opacity={slide.overlayOpacity}
                    ariaLabel={slide.ariaLabel}

                  />
                </MDBCarouselItem>
              )
                : ""}

            </MDBCarouselInner>
          </MDBCarousel>
        </MDBContainer>
      </div>
    );
  }
}

export default BannerHomeV2;